export const spliceText = (str, number) => {
    str = str || '暂无'
    var count = 0
    for (let index = 0; index < str.length; index++) {
        const element = str[index];
        if (!/[\u4e00-\u9fa5]/.test(element) && count <= (number * 2) - 35) {
            count++
        }
    }
    number = number + count
    let r_str = str.length > number
    if (r_str) {
        str = str.slice(0, number) + '...'
    }
    return str
}